import Vue from "vue";

Vue.component("wto-multi-select", {
	props: ["label", "placeholder", "items", "ids", "isReadOnly", "error", "required", "onBorder", "reference", "list"],
	data() {
		return {
			options: [],
			selectedIds: [],
			selectedList: [],
			showSelector: false,
			anchorRef: 'anchor' + this.reference,
			inputRef: 'input' + this.reference,
			names: ""
		}
	},
	methods: {
		onFocusOut: function () {
			this.showSelector = false;
		},
		getTextValue: function (ids, options) {
			let returnValue = '';
			if (ids && ids.length > 0) {
				returnValue = "";
				ids.forEach(function (id) {
					const items = options.filter(function (item) {
						return item.value === id;
					});
					if (items && items.length > 0) returnValue += items[0].text + '; ';
				});
				returnValue = returnValue.substr(0, returnValue.length - 2);
			}
			this.names = returnValue;
		},
		triggerSelector: function () {
			this.showSelector = !this.showSelector;
			this.$refs[this.inputRef].$refs.taginput.focus();
		}
	},
	computed: {
		computedValue: {
			get() {
				const ids = this.ids;
				if (!ids || ids.length === 0) return [];
				const returnIds = [];
				ids.forEach(function (id) {
					returnIds.push(id.toString());
				});
				this.getTextValue(returnIds, this.items);
				return returnIds;
			},
			set(value) {
				
				this.getTextValue(value, this.items);
				this.$emit("update:ids", value);
			}
		},
		labelClass() {
			let returnValue = 'label';

			if (this.required) returnValue += ' required-field';
			if (this.onBorder) returnValue += ' on-border';

			return returnValue;
		}
	},
	mounted() {
		this.options = this.items;
	},
	watch: {
		items: function (val) {
			this.options = val;
		},
		selectedList: function (val) {
			this.$emit("update:list", val);
		}
	},
	template: `
		<div class="control-container">
			<label :class="labelClass">{{ label }}</label>
			<b-field :type="error ? 'is-danger' : ''" :message="error">
				<a v-if="!isReadOnly" :ref="anchorRef" class="button control-collapse" @click="triggerSelector">
					<div contentEditable=true :data-text="placeholder" class="truncate-overflow content-text" :title="names">{{ names }}</div>
				</a>
				<a v-else :ref="anchorRef" class="button control-collapse">
					<div contentEditable=true :data-text="placeholder" class="truncate-overflow content-text" :title="names">{{ names }}</div>
				</a>
			</b-field>
			<div class="multi-select-control" v-show="showSelector" v-closable="{exclude: [anchorRef], handler: 'onFocusOut'}">
				<wto-tag-input-ids :ref="inputRef" :placeholder="placeholder" :items="items" :ids.sync="computedValue" :list.sync="selectedList"></wto-tag-input-ids>
			</div>
		</div>
	`
});